import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteBrand = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminBrand/deleteBrand',
    method: 'DELETE',
    params,
  });

export { deleteBrand };
